<template>
  <LayoutCard>
    <p>Dates :</p>
    <InputBoolean
      style="margin-bottom: 12px"
      v-model="store.day_select"
      label="Séléction au jour"
    />
    <VueDatePicker
      :clearable="false"
      :format="store.day_select ? 'dd/MM/y' : format"
      locale="fr"
      :format-locale="fr"
      :action-row="{ showPreview: false }"
      :enable-time-picker="false"
      :month-picker="!store.day_select"
      range
      v-model="input_value.base"
      cancel-text="Annuler"
      select-text="Valider"
      style="margin-bottom: 10px"
      :auto-apply="true"
    />
    <VueDatePicker
      v-if="compare"
      clearable
      :format="store.day_select ? 'dd/MM/y' : format"
      :format-locale="fr"
      locale="fr"
      :action-row="{ showPreview: false }"
      :enable-time-picker="false"
      range
      :month-picker="!store.day_select"
      v-model="input_value.comp"
      cancel-text="Annuler"
      select-text="Valider"
      style="margin-bottom: 10px"
      :auto-apply="true"
    />
    <CommonButton
      @click="on_compare_click"
      size="small"
      button
      class="btn-primary chart-device-comparison"
    >
      {{ compare ? 'X' : '+ Comparer avec une date' }}
    </CommonButton>
  </LayoutCard>
</template>

<script setup lang="ts">
import CommonButton from '@/components/common/CommonButton.vue'
import InputBoolean from '@/components/common/input/InputBoolean.vue'
import LayoutCard from '@/components/layout/LayoutCard.vue'
import VueDatePicker from '@vuepic/vue-datepicker'
import { computed, ref } from 'vue'
import { useChartStore, type MonthPickerDate } from '@/stores/store_chart'
import { fr } from 'date-fns/locale'

export type ChartDeviceDatePickerData = {
  base?: [Date | any, Date | any]
  comp?: [Date | any, Date | any]
}

const props = defineProps<{
  compare: boolean
  modelValue: ChartDeviceDatePickerData
}>()

const store = useChartStore()
const emits = defineEmits<{
  (e: 'update:modelValue', value: ChartDeviceDatePickerData): void
  (e: 'update:compare', value: boolean): void
}>()

const input_value = computed({
  get: () => {
    return props.modelValue
  },
  set: (v: ChartDeviceDatePickerData): void => {
    emits('update:modelValue', v)
  }
})

function on_compare_click() {
  emits('update:compare', !props.compare)
}

function format(date: Date[] | null) {
  if (date === null) return ''
  const start = date[0].toLocaleDateString('fr', { day: undefined, month: 'long', year: 'numeric' })
  if (date[1] && date[1].getMonth() != date[0].getMonth()) {
    const end = date[1].toLocaleDateString('fr', {
      day: undefined,
      month: 'long',
      year: 'numeric'
    })
    return `Période : ${capitalizeFirstLetter(start)} - ${capitalizeFirstLetter(end)}`
  }

  return `Période : ${capitalizeFirstLetter(start)}`
}

function capitalizeFirstLetter(val: string) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1)
}
</script>

<style scoped></style>
